<template>
    <div>
        <NavBarLight></NavBarLight><br><br>
        <div class="dashboard-content">
            <div class="row">
                <div class="card">
                    <div v-if="slug === 'ui-design'" class="intro text-left">
                        <h1 class="heading">What is UI Design?</h1>
                        <div>User Interface (UI) Design is responsible for the smooth flows and ease-of-use of mobile apps and websites all around you. <br><br><br>From all kinds of 
                        apps - food delivery, ride sharing, games, banking, etc. to all kinds of form factors - desktop, mobile, tablets, watches, TVs, etc. UI is the glue that binds users with technology. 
                        Pick your favourite product and you'll notice how UI is responsible for the functional and beautiful experience.<br><br><br>
                    You can learn UI Design concepts created by UI design experts. You can also practice concepts to test your knowledge and see where you stand.</div>
                        <LessonButton ctaText="LEARN UI DESIGN" @pressed="startLearning">
                        </LessonButton>
                    </div>
                    <div v-if="slug === 'ux-design'" class="intro text-left">
                        <h1 class="heading">What is UX Design?</h1>
                        <div>
                            User Experience (UX) Design is the process of making user-centric products that solve their pain-points. 
                            User Experience is one of the most important fields in Product Design and Development today as it revolves around 
                            making products functional and easy-to-use. <br><br>
                            Learn the User Experience process in created by UX design experts. 
                        </div>
                        <LessonButton ctaText="LEARN UX DESIGN" @pressed="startLearning">
                        </LessonButton>
                    </div>
                    <div v-if="slug === 'react'" class="intro text-left">
                        <h1 class="heading">What is React?</h1>
                        <div>
                            Created by Facebook in 2013, React has taken the Front-end development world by storm.
                            React makes it painless to create interactive UIs and is optimal for fetching rapidly changing data 
                            that needs to be recorded. <br><br>
                            Learn React concepts created by experts.  
                        </div>
                        <LessonButton ctaText="LEARN REACT" @pressed="startLearning">
                        </LessonButton>
                    </div>
                    <div v-if="slug === 'react-native'" class="intro text-left">
                        <h1 class="heading">What is React Native?</h1>
                        <div>
                            React Native is a framework for writing real, natively rendering mobile applications for Android and iOS. <br><br>
                            Learn React Native concepts created by experts. 
                        </div>
                        <LessonButton ctaText="LEARN REACT NATIVE" @pressed="startLearning">
                        </LessonButton>
                    </div>
                
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import NavBarLight from '@/components/NavBarLight.vue'
import LessonButton from '@/components/LessonButton.vue'
import firebase from '../services/firebase'

export default {
    name: 'LearnConcepts',
    components: {
        NavBarLight,
        LessonButton
    },
    data: function() {
        return {
            slug: this.$route.params.slug
        }
    },
    methods: {
        startLearning: function() {
            console.log("clicked startLearning");
            console.log("taking you to " + this.slug);
            mixpanel.track("going to learn concept", {
                "learning_module": this.slug,
                "user_id": firebase.auth().currentUser.uid,
                "email": firebase.auth().currentUser.email
            });

            this.$router.push(this.$route.path + "/start-learning");
        }
    }
}
</script>


<style scoped>

    .dashboard-content {
        padding-top:3%;
        padding-bottom: 2%;
    }

    .heading {
        font-size: 1.55rem;
        margin-bottom: 5%;
    }

    .card {
		border:none;
		box-shadow: 2px 1px 2px 0px rgba(1, 2, 2, 0.15);
        transition: all 0.3s ease;
		font-family: Helvetica;
		cursor:pointer;
		border-radius: 10px;
        color: #444;
        width: 100%;
        margin-left: 18%;
        margin-right: 18%;
        padding-top: 1%;
        padding-bottom: 5%;
        margin-bottom: 4%;
        margin-top: 0%;
    }

    .intro {
        margin-left: 8%;
        margin-right: 8%;
    }

</style>
